<template>
  <div class="row main-content">
    <div class="col">
      <div
        v-if="isProcessing"
        class="text-center"
      >
        <img
          src="@/assets/img/loader.gif"
          class="mx-auto d-block center-block"
        >
      </div>

      <div v-else>
        <h1 class="page-title font-custom text-uppercase mt-3">
          {{ $t("title.request.details") }}
        </h1>

        <div
          v-if="responseErr"
          class="alert alert-danger text-center border-0 shadow-sm rounded-0"
        >
          <strong>
            {{ $t("error." + `${responseErr}`) }}
          </strong>
        </div>

        <!-- Cancel modal validation -->
        <div
          v-if="requestDetail"
          id="cancelModal"
          class="modal fade"
        >
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <!-- Modal Header -->
              <div class="modal-header">
                <h4 class="modal-title">
                  {{ $t('label.request.requestCancellation') }}
                </h4>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                />
              </div>

              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-default"
                  data-bs-dismiss="modal"
                >
                  {{ $t('button.cancel') }}
                </button>
                <BaseButton
                  type="button"
                  class="btn btn-primary"
                  data-bs-dismiss="modal"
                  @click-base-button-event-emitter="cancel()"
                >
                  {{ $t('button.confirm') }}
                </BaseButton>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="requestDetail"
        >
          <div
            class="row"
          >
            <i18n-t
              class="text-start mb-2"
              keypath="label.request.infoDetail"
              tag="div"
              scope="global"
            >
              <strong>{{ requestID }}</strong>
              {{ requestDetail.requestType }}
              <strong>{{ $filters.dateYYYYMMDD(requestDetail.requestDate) }}</strong>
            </i18n-t>
            <div class="text-start mb-2">
              {{ $t("label.request.requestUser") }} :
              <strong>{{ requestDetail.requestUser }}</strong>
            </div>
          </div>
          <div class="row">
            <i18n-t
              class="text-start mb-2"
              keypath="label.request.statusInfo"
              tag="div"
              scope="global"
            >
              <strong>{{ $t("label.request." + requestDetail.requestStatus) }}</strong>
            </i18n-t>
            <!-- <button
              type="button"
              class="base-button font-custom rounded-pill btn btn-primary font-inverted btn-export m-1"
              @click="showEdit()"
            >
              {{ $t("button.edit") }}
            </button> -->
          </div>
          <div
            v-if="requestDetail.requestProductDescription[0].params.length > 0
              && (requestDetail.requestType === 'PRODUCT_UPDATE'
                || (requestDetail.requestType === 'PRODUCT_CREATION'
                  && requestDetail.requestStatus === 'DONE'))"
            class="row"
          >
            <i18n-t
              class="text-start mb-2"
              keypath="label.request.productDetail"
              tag="div"
              scope="global"
            >
              <span
                role="button"
                class="clickable-div"
                @click="showProduct(requestDetail.requestProductDescription[0].params[0].value[0])"
              >
                {{ requestDetail.requestProductDescription[0].params[0].value[0] }}
              </span>
            </i18n-t>
          </div>
          <div
            v-if="updatedParams && updatedParams.params && Object.keys(updatedParams.params).length > 0
              && requestDetail.requestStatus !== 'DONE'
              && requestDetail.requestStatus !== 'FAILED'"
            class="col p-0"
          >
            <div class="text-start mb-2 me-1">
              <p v-if="requestDetail.requestStatus === 'IN_PROGRESS'">
                {{ $t("label.request.modifiedParamsInProgress") }}
              </p>
              <p v-else-if="requestDetail.requestStatus === 'PENDING'">
                {{ $t("label.request.modifiedParamsPending") }}
              </p>
              <p v-else-if="requestDetail.requestStatus === 'CANCELLED'">
                {{ $t("label.request.modifiedParamsCancelled") }}
              </p>
            </div>
            <ul>
              <li
                v-for="(param, key) in updatedParams.params"
                :key="key"
              >
                <span
                  v-if="key && key.includes('-')"
                  class="fw-bold"
                >
                  {{ key }} :
                </span>
                {{ param }}
              </li>
            </ul>
          </div>
          <div
            v-if="updatedParams && updatedParams.params && Object.keys(updatedParams.params).length > 0
              && requestDetail.requestStatus === 'FAILED'"
            class="col p-0"
          >
            <div class="text-start mb-2 me-1">
              <p>
                {{ $t("label.request.modifiedParamsFailed") }}
              </p>
            </div>
            <ul>
              <li
                v-for="(param, index) in updatedParams.params"
                :key="index"
              >
                <span
                  class="fw-bold"
                >
                  {{ param }}
                </span>
              </li>
            </ul>
          </div>
          <div
            v-else-if="errUpdatedParams"
          >
            <p class="errorMessage">
              <strong>
                {{ $t("error." + errUpdatedParams) }}
              </strong>
            </p>
          </div>
          <div
            v-else-if="!updatedParams && requestDetail.requestStatus !== 'DONE' && requestDetail.requestType !== 'PRODUCT_CREATION'"
          >
            <p class="errorMessage">
              <strong>
                {{ $t("label.request.noModifiedParamsFound") }}
              </strong>
            </p>
          </div>

          <template v-if="requestDetail.requestStatus === 'PENDING' && hasPermission('product:create')">
            <!-- Ajout d'une permission particulière à la place du v-if actuel?-->
            <div
              class="card-body bg-light mb-4 d-md-flex justify-content-md-end"
            >
              <!-- <button
                type="button"
                class="base-button font-custom rounded-pill btn btn-primary font-inverted btn-export m-1"
                @click="showEdit()"
              >
                {{ $t("button.edit") }}
              </button> -->
              <BaseButton
                v-if="requestDetail.requestStatus === 'PENDING'"
                type="button"
                class="base-button font-custom rounded-pill btn btn-danger font-inverted btn-export m-1"
                data-bs-toggle="modal"
                data-bs-target="#cancelModal"
              >
                {{ $t('button.cancel') }}
              </BaseButton>
            </div>
          </template>

          <div
            v-if="requestDetail.requestProductDescription
              && (requestDetail.requestType === 'PRODUCT_CREATION'
                || (requestDetail.requestType === 'PRODUCT_UPDATE' && requestDetail.requestStatus !== 'DONE'))"
          >
            <div
              v-for="productDescription in requestDetail.requestProductDescription"
              :id="'accordion' + productDescription.code"
              :key="productDescription.id"
              class="card rounded-0 mb-4"
            >
              <div
                :id="'heading' + productDescription.code"
              >
                <button
                  class="accordion-button card-header font-accent fw-bold"
                  type="button"
                  data-bs-toggle="collapse"
                  :href="'#collapse' + productDescription.code"
                  aria-expanded="false"
                  :aria-controls="'collapse' + productDescription.code"
                >
                  {{ productDescription.code }} :
                  {{ productDescription.description }}
                </button>
              </div>
              <div
                :id="'collapse' + productDescription.code"
                :aria-labelledby="'heading' + productDescription.code"
                :data-bs-parent="'#accordion' + productDescription.code"
                class="card-body collapse"
              >
                <div
                  v-for="param in productDescription.params"
                  :key="param.code"
                  :class="[isModified(param.code) ? 'updatedParam row p-1' : 'row p-1']"
                >
                  <div
                    class="col-3 text-end"
                    style="padding-right: 4px;"
                  >
                    <strong>
                      {{ param.code }} :
                    </strong>
                  </div>
                  <div
                    class="col-3"
                    style="padding-left: 0; font-style: italic;"
                  >
                    <span>{{ param.description }}</span>
                  </div>
                  <div
                    class="col"
                  >
                    <div
                      v-for="value in param.value"
                      :key="value.id"
                    >
                      {{ value }} <br>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
          >
            <!-- Pavé modification avant après, si modification réussie -->
            <div
              id="accordionParamsDiff"
              class="card rounded-0 mb-4"
            >
              <div
                id="headingParamsDiff"
                data-bs-toggle="collapse"
                href="#collapseParamsDiff"
                aria-expanded="false"
                aria-controls="collapseParamsDiff"
                class="card-header font-accent fw-bold"
              >
                {{ paramsDiff.productRef }} :
                {{ paramsDiff.diffTypeDesc }}
              </div>
              <div
                id="collapseParamsDiff"
                aria-labelledby="headingParamsDiff"
                data-bs-parent="#accordionParamsDiff"
                class="card-body collapse"
              >
                <table>
                  <thead class="h5">
                    <tr>
                      <th class="paramTd text-start p-2">
                        {{ $t("label.request.param") }}
                      </th>
                      <th class="valueTd text-end p-2">
                        {{ $t("label.request.valueBeforeUpdate") }}
                      </th>
                      <th class="valueTd text-start p-2">
                        {{ $t("label.request.valueAfterUpdate") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="diff in paramsDiff.differences"
                      :key="diff.code"
                    >
                      <td class="text-start p-2">
                        <strong>{{ diff.code }} :</strong>
                        <span style="padding-left:0.5em ;font-style: italic;">
                          {{ diff.description }}
                        </span>
                      </td>
                      <td
                        class="text-end p-2"
                      >
                        <span
                          v-if="diff.leftValue.length > 1"
                        >
                          <div
                            v-for="value in diff.leftValue"
                            :key="value.id"
                          >
                            {{ value }} <br>
                          </div>
                        </span>
                        <span v-else-if="diff.leftValue.length === 1 && diff.leftValue[0] !== ''">
                          {{ diff.leftValue[0] }}
                        </span>
                        <span
                          v-else
                          :title="$t('label.request.undefined')"
                        >
                          Ø
                        </span>
                      </td>
                      <td
                        class="text-start p-2"
                      >
                        <span
                          v-if="diff.rightValue.length > 1"
                        >
                          <div
                            v-for="value in diff.rightValue"
                            :key="value.id"
                          >
                            {{ value }} <br>
                          </div>
                        </span>
                        <span v-else-if="diff.rightValue.length === 1 && diff.rightValue[0] !== ''">
                          {{ diff.rightValue[0] }}
                        </span>
                        <span
                          v-else
                          :title="$t('label.request.undefined')"
                        >
                          Ø
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <SuccessDialogProduct ref="successDialogRef" />
    <goTopButton />
  </div>
</template>

<script src="./RequestDetail.js"></script>

<style src="./RequestDetail.scss" scoped lang="scss"></style>
